import reducer from 'common/state/user/reducer';

export default reducer;
export * from 'common/state/user/actions';
